import Prism from 'prismjs'
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace'
import 'prismjs/plugins/toolbar/prism-toolbar'
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-ini'
import 'prismjs/components/prism-apacheconf'
import 'prismjs/components/prism-nginx'
import 'prismjs/components/prism-yaml'
import 'prismjs/components/prism-docker'
import 'prismjs/components/prism-json'

// To Load the CSS: Add @import '~prismjs/themes/prism-okaidia.css'; to the necessary .less file

export function initializePrism() {
    // if you are intending to use Prism functions manually, you will need to set:
    Prism.manual = true

    Prism.highlightAll()
}
